<template>
    <div>
        <!--创建项目-->
		<el-dialog :title="theAlertTitle" :visible.sync="proAdd" :show-close=false width="800px" :close-on-click-modal="false">
			<div class="add-step" v-if="step1 || step2">
				<div class="step1">
					<img src=".././assets/images/project_add_one_text_sel.png" width="18">
					<span>{{$store.state.i18n.setProjectName[$store.state.CN_EN]}}</span>
				</div>
				<div class="step2" :class="step2 ? 'active' : ''">
					<img src=".././assets/images/project_add_two_text_sel.png" width="18" class="img-sel">
					<img src=".././assets/images/project_add_two_text.png" width="18" class="img-unsel">
					<span>{{$store.state.i18n.inviteProjectMember[$store.state.CN_EN]}}</span>
				</div>
			</div>
			<div class="form-info" v-if="step1">
				<div class="cs-mb-15">{{$store.state.i18n.projectName[$store.state.CN_EN]}}</div>
                <div class="pro-name">
                    <el-input v-model="theName" :placeholder="$store.state.i18n.enterProjectName[$store.state.CN_EN]"></el-input>
                </div>
                <div class="file-wrap">
					<img v-if="projectCoverImage.length == 0" src=".././assets/images/upload.png" width="202">
					<img v-else :src="projectCoverImage" class="file-img" >
					<input type="file" class="input-file" id="uploadProjectCover"/>
                </div>
                <div class="tip-text">{{$store.state.i18n.pictureSize[$store.state.CN_EN]}}</div>
			</div>
			<div class="form-info" v-if="step2">
				<div class="cs-mb-15">
					<span>{{$store.state.i18n.projectMember[$store.state.CN_EN]}}</span>
					<span class="text-user" @click="ImportList">{{$store.state.i18n.importMemberFromProject[$store.state.CN_EN]}}</span>
					<div class="clearfix"></div>
				</div>
				<div class="table-contain">
					<table cellspacing="0" cellpadding="0" class="pro-table user-table">
						<thead>
						<tr>
							<th class="thead-sticky" width="15%">{{$store.state.i18n.memberName[$store.state.CN_EN]}}</th>
							<th class="text-left thead-sticky" width="32%">{{$store.state.i18n.emailAddress[$store.state.CN_EN]}}</th>
							<th class="text-left thead-sticky" width="25%">{{$store.state.i18n.role[$store.state.CN_EN]}}</th>
							<th class="thead-sticky" width="13%"></th>
							<th class="thead-sticky" width="15%">{{$store.state.i18n.operate[$store.state.CN_EN]}}</th>
						</tr>
						</thead>
						<tbody>
                            <tr>
								<td>{{memberName}}</td>
                                <td class="text-left">
                                    <el-input size="small" v-model="memberEmail" disabled></el-input>
                                </td>
                                <td class="text-left">
                                    <el-input  size="small" :value="$store.state.i18n.projectManager[$store.state.CN_EN]" disabled></el-input>
                                </td>
                                <td>
                                    <el-checkbox disabled checked>{{$store.state.i18n.visible[$store.state.CN_EN]}}</el-checkbox>
                                </td>
                                <td></td>
                            </tr>
                            <tr v-for="(item, index) in memberInfoJson" :key="item.theName">
                                <td>{{item.name}}</td>
                                <td class="text-left">
                                    <div class="email-input">
                                        <el-input v-model="item.email" :disabled="item.isSelected" :placeholder="$store.state.i18n.enterEmail[$store.state.CN_EN]" size="small"></el-input>
                                    </div>
                                </td>
                                <td class="text-left">
                                    <div class="email-input">
                                        <el-select v-model="item.role" :placeholder="$store.state.i18n.choose[$store.state.CN_EN]" size="small">
                                            <el-option
                                                v-for="item in roleList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </td>
                                <td>
                                    <el-checkbox v-model="item.canBeContacted">{{$store.state.i18n.visible[$store.state.CN_EN]}}</el-checkbox>
                                </td>
                                <td>
                                    <div v-if="index != memberInfoJson.length - 1" class="handle" @click="deleteMemberInfo(index)">
                                        <img src=".././assets/images/list_operation_del.png" width="14" class="icon">
                                        <img src=".././assets/images/list_operation_del_selected.png" width="14" class="icon-sel">
                                        <span class="vertical-m">{{$store.state.i18n.delete[$store.state.CN_EN]}}</span>
                                    </div>
                                </td>
                            </tr>
						</tbody>
					</table>
				</div>
			</div>
			<div v-if="userList">
				<div class="cs-mb-15">
					<span>{{$store.state.i18n.lastCooperation[$store.state.CN_EN]}}</span>
					<span class="text-user">{{$store.state.i18n.choose[$store.state.CN_EN]}}（{{theSelectedCount}}）{{$store.state.i18n.people[$store.state.CN_EN]}}</span>
					<div class="clearfix"></div>
				</div>
				<div class="table-contain">
					<table cellspacing="0" cellpadding="0" class="pro-table user-table">
						<thead>
						<tr>
                            <th class="thead-sticky" width="20%">{{$store.state.i18n.memberName[$store.state.CN_EN]}}</th>
							<th class="text-left thead-sticky" width="50%">{{$store.state.i18n.emailAddress[$store.state.CN_EN]}}</th>
							<th class="thead-sticky" width="30%">{{$store.state.i18n.operate[$store.state.CN_EN]}}</th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="item in memberList" :key="item.email">
                            <td>{{item.theName}}</td>
							<td class="text-left">
								<a v-if="item.headImagePath == null || item.headImagePath.length == 0" class="head-img img1">{{item.firstLetter}}</a>
								<!--有头像显示-->
								<a v-else>
									<img :src="item.headImagePath" class="head-img">
								</a>
								<span class="text-email">{{item.email}}</span>
							</td>
							<td>
								<div class="sel-user">
									<el-checkbox :checked="selectMemberArr.indexOf(item) > -1" @change="selectMemberWithIndex($event, item)"></el-checkbox>
								</div>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<div class="cs-btn btn-cancel" @click="dismiss" v-if="step1 || step2">{{$store.state.i18n.cancel[$store.state.CN_EN]}}</div>
				<div class="cs-btn btn-sure" v-if="step2" @click="prev">{{$store.state.i18n.previous[$store.state.CN_EN]}}</div>
				<div class="cs-btn btn-sure" @click="next" v-if="step1">{{$store.state.i18n.next[$store.state.CN_EN]}}</div>
				<div class="cs-btn btn-sure" @click="startAddProjectRequest" v-if="step2">{{$store.state.i18n.confirmCreateProject[$store.state.CN_EN]}}</div>
				<div class="cs-btn btn-cancel" v-if="userList" @click="useCancle">{{$store.state.i18n.back[$store.state.CN_EN]}}</div>
				<div class="cs-btn btn-sure" v-if="userList" @click="useMakeSure">{{$store.state.i18n.ok[$store.state.CN_EN]}}</div>
			</div>
		</el-dialog>
    </div>
</template>

<script>

    import Vue from 'vue'

    // 引用API文件
    import api from '../assets/js/common/ServerInterface.js'
    Vue.prototype.$api = api

	import { Select, Option, Input, Dialog, Checkbox, Message, Loading} from 'element-ui'
	Vue.use( Select )
	Vue.use( Option )
	Vue.use( Input )
    Vue.use( Dialog )
    Vue.use( Checkbox )
	Vue.prototype.$message = Message
	Vue.use(Loading.directive)
	Vue.prototype.$loading = Loading.service

    import fileUpload from '../assets/js/common/FileUpload'

    export default {
        name    :   "AddProjectAlert",
        data() {
            return {
                proAdd  :   false,
				roleValue   :   "",
				step1       :   true,
				step2       :   false,
                userList    :   false,

				memberName  : "",
			 	memberEmail : "",

				/******** 请求参数 *********/
                // 项目名称
                theName     : "",
                // 项目图片
                imagePath   : null,
                // 项目结束日期
                endDatetimeStr  : null,
                // 邀请用户信息
				memberInfoJson  : [ { name: '', email: '', canBeContacted: false, role:'' , isSelected: false } ],

				/******** 返回参数 *********/
				memberList		:	[],

				selectMemberArr 	: 	[],
				selectMemberArrCopy	:	[],
				projectCoverImage : ""
            }
        },
		computed: {
			roleList() {
				return [{ value: 'RoleDeveloper', label: this.$store.state.i18n.developer[this.$store.state.CN_EN] },
						{ value: 'RoleProjectManager', label: this.$store.state.i18n.projectManager[this.$store.state.CN_EN] },
						{ value: 'RoleQualityAssurance', label: this.$store.state.i18n.qa[this.$store.state.CN_EN] },
						{ value: 'RoleCustomer', label: this.$store.state.i18n.client[this.$store.state.CN_EN] }]
			},
			theAlertTitle() {
				if (this.userList == true) {
					return this.$store.state.i18n.importMember[this.$store.state.CN_EN]
				} else {
					return this.$store.state.i18n.createProject[this.$store.state.CN_EN]
				}
			},
            addProjectRequestForm() {
                return {
                    interfaceVersion    :	19000101,
					theName             :   this.theName,
					imagePath			:   this.projectCoverImage,
                    memberInfoJsonStrArr:   JSON.stringify(this.memberInfoJson)
				}
			},
			getMemberListForProjectRequestForm() {
                return {
                    interfaceVersion    :	19000101
				}
			},
			theSelectedCount () {
				return this.selectMemberArr.length
			}
        },
        watch: {
            memberInfoJson: {
                deep:true,
                handler:function(newValue, oldValue) {
					var member = newValue[newValue.length - 1]
                    if (member.email.length > 0 && member.role.length > 0) {
                        newValue.push({ name: '', email: '', canBeContacted: false, role:'', isSelected: false })
					}
                }
            }
		},
		mounted () {
            //从Cookie中获取信息
            this.memberName = localStorage.getItem("memberName")
			this.memberEmail = localStorage.getItem("email")
		},
        methods: {
            startAddProjectRequest() {
				let loadingInstance = Loading.service({
					lock: true,
					text: this.$store.state.i18n.createProjectAlert[this.$store.state.CN_EN],
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});

				this.$api.post('/smProjectAdd.smhtml', this.addProjectRequestForm, jsonObj => {
					this.$message.success(jsonObj.info)

					//关闭elementUi-Loading
					this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
						loadingInstance.close();
					});

                	this.$parent.startRequest()
					this.dismiss()

				},jsonObj => {
					this.$message.error(jsonObj.info)

					this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
						loadingInstance.close();
					});
				})
			},
            startGetMemberListForProjectRequest() {
				this.$api.post('/smMemberListForProject.smhtml', this.getMemberListForProjectRequestForm, jsonObj => {
					this.memberList = jsonObj.memberList
				},jsonObj => {

				})
			},
            deleteMemberInfo(index) {
				if (this.memberInfoJson.length > 1) {

					var member = this.memberInfoJson[index]

					this.deleteItemForSelectArr(member)

					this.memberInfoJson.splice(index, 1)

				} else {
					this.memberInfoJson = [ { name: '', email: '', canBeContacted: false, role:'', isSelected: false } ]
				}
			},
			selectMemberWithIndex(isSelect, member) {

				if (isSelect) { //选中
					if (this.selectMemberArr.indexOf(member) == -1) {
						this.selectMemberArr.push(member)
					}
				} else { //取消选中
					let index = this.selectMemberArr.indexOf(member)
					if (index > -1) {
						this.selectMemberArr.splice(index, 1)
					}
				}
			},
            dismiss() {

				this.step1 = true
				this.step2 = false

				this.theName = ""
				this.projectCoverImage = ""
				this.selectMemberArr = []
				this.selectMemberArrCopy = []
				this.memberInfoJson = [{ name: '', email: '', canBeContacted: false, role:'', isSelected: false }]

                this.proAdd = false
            },
            show() {
				this.proAdd = true
            	let vue = this

				Vue.nextTick(function () {
					// console.log(document.getElementById("uploadProjectCover"))
					fileUpload.upload("uploadProjectCover", url => {
						// console.log('url is ' + url)
						vue.projectCoverImage = url
						// console.log('this.projectCoverImage is ' + this.projectCoverImage)
						vue.$forceUpdate()
					})
				})
            },
			next(){

				if (this.theName.length == 0) {
					this.$message.error(this.$store.state.i18n.enterProjectName[this.$store.state.CN_EN])
					return
				}

				if (this.projectCoverImage.length == 0) {
					this.$message.error(this.$store.state.i18n.uploadProjectPicture[this.$store.state.CN_EN])
					return
				}

				this.startGetMemberListForProjectRequest()

				this.step1 = false
				this.step2 = true
			},
			prev(){
				this.step1 = true
				this.step2 = false
			},
			ImportList(){
				this.step1 = false
				this.step2 = false
				this.userList = true

				// 判断是否有输入和成员列表相同的邮箱，有就添加，不过要判断是否在已加入的列表中
				for (let i = 0; i < this.memberInfoJson.length; i += 1) {
					let member = this.memberInfoJson[i]
					for (let j = 0; j < this.memberList.length; j += 1) {
						let member2 = this.memberList[j]
						if (member.email == member2.email) {
							let needPush = true
							for (let k = 0; k < this.selectMemberArr.length; k += 1) {
								let memberObj =  this.selectMemberArr[i]
								if (memberObj && memberObj.email == member.email) {
									needPush = false
									break;
								}
							}
							if (needPush) {
								this.selectMemberArr.push(member)
							}
							break;
						}
					}
				}

				// 判断是否有修改过之前添加的成员，有就从选中中删除
				this.selectMemberArr = this.selectMemberArr.filter((memberObj) => {
					for (let i = 0; i < this.memberInfoJson.length; i += 1) {
						let member = this.memberInfoJson[i]
						if (member.email == memberObj.email) {
							return true
						}
					}
					return false
				})

			},
			useCancle(){
				this.step2 = true
				this.userList = false
				this.selectMemberArr = [].concat(this.selectMemberArrCopy)
			},
			useMakeSure(){
				this.step2 = true
				this.userList = false
				this.selectMemberArrCopy = [].concat(this.selectMemberArr)

				// 删除取消选中的邮箱
				this.memberInfoJson = this.memberInfoJson.filter((item) => {
					return this.checkNeedDeleteForInfoJson(item)
				})

				// 删除已添加过的邮箱
				let arr =  this.selectMemberArr.filter((member) => {
					return this.checkNeedAdd(member)
				})

				let member = this.memberInfoJson[this.memberInfoJson.length - 1]
				if (member.email.length > 0) {
					for (let i = 0; i < arr.length ;i += 1) {
						this.memberInfoJson.push({ name: arr[i].theName, email: arr[i].email, canBeContacted: false, role:'RoleDeveloper', isSelected: true })
					}
					this.memberInfoJson.push({ name: '', email: '', canBeContacted: false, role:'', isSelected: false })
				} else {
					this.memberInfoJson.splice(this.memberInfoJson.length - 1, 1)
					for (let i = 0; i < arr.length; i += 1) {
						this.memberInfoJson.push({ name: arr[i].theName, email: arr[i].email, canBeContacted: false, role:'RoleDeveloper', isSelected: true })
					}
					this.memberInfoJson.push({ name: '', email: '', canBeContacted: false, role:'', isSelected: false })
				}
			},
			checkNeedDeleteForInfoJson(item) {
				if (this.selectMemberArr.indexOf(item) == -1) {
					for (let i = 0; i < this.memberList.length; i += 1) {
						let member = this.memberList[i]
						if (member.email == item.email) {
							return false
						}
					}
				}
				return true
			},
			deleteItemForSelectArr(member) {

				this.selectMemberArr =  this.selectMemberArr.filter((memberObj) => {
					return memberObj.email != member.email;
				})

				this.selectMemberArrCopy =  this.selectMemberArrCopy.filter((memberObj) => {
					return memberObj.email != member.email;
				})

			},
			checkNeedAdd(memberObj) {
				for (var i = 0; i < this.memberInfoJson.length; i += 1) {
					let member = this.memberInfoJson[i]
					if (member.email == memberObj.email) {
						return false
					}
				}
				return true
			}
        },
    }
</script>

<style scoped>
	/*弹窗*/
    .pro-name{
        width: 600px;
    }
	.add-step{
		background: #f8f8f8;
		text-align: center;
		padding: 15px;
	}
	.step1,.step2{
		display: inline-block;
		height: 35px;
		line-height: 35px;
	}
	.step1{
		width: 227px;
		background: url(".././assets/images/project_add_one_bg_sel.png") no-repeat;
		background-size: cover;
		color: #29b6b0;
	}
	.step1 span,.step2 span{
		vertical-align: middle;
		display: inline-block;
	}
	.step1 img,.step2 img{
		margin: -1px 10px 0 10px;
	}
	.step2{
		width: 210px;
		background: url(".././assets/images/project_add_two_bg.png") no-repeat;
		background-size: cover;
		color: #666666;
	}
	.step2 .img-sel{
		display: none;
	}
	.step2.active{
		background: url(".././assets/images/project_add_two_bg_sel.png") no-repeat;
		background-size: cover;
		color: #29b6b0;
	}
	.step2.active .img-unsel{
		display: none;
	}
	.step2.active .img-sel{
		display: inline-block;
	}
	.form-info{
		margin: 30px 0;
	}
	.user-table{
		width: 100%;
	}
	.user-table th{
		color: #333;
	}
	.user-table th{
		padding: 15px;
	}
	.user-table td{
		padding: 5px;
        text-align: center;
	}
    .user-table .text-left{
        text-align: left;
    }
	.thead-sticky{
		position: sticky;
		top: 0px;
		background: #f7f7f7;
		z-index: 10;
	}
	.table-contain{
		height: 300px;
		overflow:auto;
	}
	.text-user{
		color: #409eff;
		text-decoration: underline;
		float: right;
		cursor: pointer;
	}
	.text-email{
		margin-left: 7px;
		vertical-align: middle;
	}
	.head-img{
		vertical-align: middle;
	}
	.sel-user{
		text-align: center;
	}
    .file-wrap {
        position: relative;
        overflow: hidden;
        display: inline-block;
        vertical-align: middle;
        margin-top: 20px;
    }
    .tip-text{
        margin-top: 10px;
        font-size: 12px;
    }
    .file-img {
        max-height: 135px;
        display: inline-block;
    }
    .input-file {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        font-size: 150px;
        opacity: 0;
    }
</style>
<style>
	.email-input input{
		background: #f7f7f7;
		border: none;
	}
	.sel-user .el-checkbox__inner{
		width: 18px;
		height: 18px;
	}
	.sel-user .el-checkbox__inner::after{
		left: 6px;
		top: 3px;
	}
    .el-input__inner{
        padding: 0 10px;
    }
</style>
